export default (value) => String(value).replace(/^0(\d+)/, '$1');
